/* eslint-disable @typescript-eslint/no-unsafe-member-access */
'use client';

import { IS_PREVIEW } from '@/util/constants';
import { logger } from '@/utils/loggerUtils';
import { useReportWebVitals } from 'next/web-vitals';

export function WebVitals() {
  useReportWebVitals((metric) => {
    const isLocalOrPreview =
      IS_PREVIEW || window.location.hostname === 'localhost';

    if (!isLocalOrPreview) {
      return;
    }
    switch (metric.name) {
      case 'TTFB': {
        // time to first byte
        logger.log('TTFB:', metric.rating, metric);
        break;
      }

      case 'LCP': {
        // largest contentful paint
        logger.log('LCP:', metric.rating, metric);
        break;
      }

      case 'CLS': {
        // cumulative layout shift
        logger.log('CLS:', metric.rating, metric);
        break;
      }

      case 'FCP': {
        // first contentful paint
        logger.log('FCP:', metric.rating, metric);
        break;
      }

      case 'FID': {
        // first input delay
        logger.log('FID:', metric.rating, metric);
        break;
      }
    }
  });

  return null;
}
